import React from 'react';
import { Navigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import LoginForm from './LoginForm';

const LoginPage = ({ baseUrl }) => {
  const { authState } = useOktaAuth();

  if (!authState) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-warning" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (authState.isAuthenticated) {
    return <Navigate to="/profile" replace />;
  }

  return (
    <div className="login-page-container">
      <LoginForm baseUrl={baseUrl} />
    </div>
  );
};

export default LoginPage;